import React, { useEffect, useRef, useState } from 'react'
import CustomTable from '../../../components/customTable/customTable';
import Accordian from '../../../components/Accordian';
import { useDispatch, useSelector } from 'react-redux';
import IpoAccordian from '../../../components/IpoAccordian';
import { useLocation, useParams } from 'react-router-dom';
import { getIpoDetail, gmpDetails } from '../../../api/IposApi';
import { startMasterLoding, stopMasterLoding } from '../../../store/slice/masterSlice';
import { setIpoDetail } from '../../../utils/npm';
import { formatDate, formatDateWithDayNumber, formatIndianPrice } from '../../../components/CommonFunction';

export const GmpDetails = ({ location }) => {

    const { faqData, error, loading } = useSelector(state => state.fagListData)
    const { ipoDetailData, ipoDetailLoading } = useSelector(state => state.ipoDetail)
    const isloading = useSelector((state) => state.masterSlice.isloading);
    const [gmpDetailsData, setGmpDetailsData] = useState([])
    const { id } = useParams()

    const fetch = async () => {
        // setIsLoading(true)
        const GMPResponse = await gmpDetails(id?.toUpperCase())

        if (GMPResponse && GMPResponse.meta && GMPResponse.meta.status_code === 200) {
            setGmpDetailsData(GMPResponse?.data)
        }

        // setIsLoading(false)
    }

    const isFirstRun = useRef(true);

    useEffect(() => {
        // if (isFirstRun.current) {
        //     isFirstRun.current = false;
        //     return; 
        // }
        fetch()
    }, [id])

    // ---------------------------- Details Data --------------------------------------

    const [ipoDetailsCol, setIpoDetailsCol] = useState([])

    {
        /*---------------------- columnCapitalinfra ------------------------------ */
    }

    const columnCapitalinfra = [
        {
            title: "GMP Date",
            dataIndex: "gmp_date",
            key: "gmp_date",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {formatDate(text)}
                </span>
            ),
        },
        {
            title: "IPO Price",
            dataIndex: "ipo_price",
            key: "ipo_price",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "GMP	",
            dataIndex: "gmp",
            key: "gmp",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Estimated Listing Price",
            dataIndex: "estimate",
            key: "estimate",
            width: "60%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Last Updated",
            dataIndex: "last_update",
            key: "last_update",
            width: "50%", // Set width as a percentage of total table width
            render: (text) => (
                <span
                    style={{
                        display: "flex",
                        justifyContent: "flex-start",
                        whiteSpace: "nowrap",
                        // textDecoration: "underline",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                    }}
                    className="company-name-table table-cell-typo"
                >
                    {text}
                </span>
            ),
        },
    ];

    function transformIPOData(data) {
        return data?.map(item => {
            const gmpValue = parseFloat(item.gmp) || 0; // Convert GMP to number
            const ipoPrice = item.ipo_price ? parseFloat(item.ipo_price) : 0; // Default IPO price
            const estimatedPrice = ipoPrice + gmpValue; // Calculate estimated listing price
            const percentageChange = ipoPrice > 0
                ? ((estimatedPrice - ipoPrice) / ipoPrice * 100).toFixed(2)
                : '0.00';

            return {
                gmp_date: item.gmp_date, // Convert to DD-MM-YYYY
                ipo_price: formatIndianPrice(ipoPrice),
                gmp: `₹${gmpValue}`,
                sub_2: '--',
                estimate: `₹${formatIndianPrice(estimatedPrice)} (${percentageChange}%)`,
                last_update: new Date(item.updated_at).toLocaleString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', hour: '2-digit', minute: '2-digit' }).replace(',', ''),
            };
        });
    }

    useEffect(() => {
        const transferData = transformIPOData(gmpDetailsData?.ipo_gmp);
        setIpoDetailsCol(transferData)
    }, [gmpDetailsData])

    return (
        <>
            <div className='mainDetailsPage'>
                <div className='content'>
                    <p>
                        {ipoDetailData?.company_name} was listed on the stock exchange on {ipoDetailData?.listing_date}. The IPO was subscribed {ipoDetailData?.subscription}x. The last GMP for {ipoDetailData?.company_name} IPO was ₹{ipoDetailData?.listed_price}, updated on {formatDateWithDayNumber(ipoDetailData?.updated_at)}. As per the last GMP, the expected profit/loss for the IPO was {ipoDetailData?.gmp}%.
                    </p>
                    <p>
                        The issue price of {ipoDetailData?.company_name} was ₹{formatIndianPrice(ipoDetailData?.issue_amount)}, listed at a price of ₹{formatIndianPrice(ipoDetailData?.listed_price)}, which is {ipoDetailData?.qibs_offered}% higher than the allotment price.
                    </p>
                    <p className='text-red-600'>
                        The expected IPO listing price as per grey market was ₹{formatIndianPrice(ipoDetailData?.listed_price)}, listed above GMP price and marked as positive listing for GMP.
                    </p>
                </div>

                <div className='content-box'>
                    {ipoDetailsCol?.length > 0 &&
                        <div className="flex    xl:space-x-6">
                            <div className="relative flex flex-col my-6 bg-white shadow-sm border border-slate-200 rounded-lg blog_card overflow-x-auto">
                                <div className="mb-0 border-b border-slate-200 pt-3 pb-2 px-5 header_blog">
                                    <span className="text-sm text-slate-600 font-medium header_blog_span">
                                        {ipoDetailData?.company_name} GMP Trend
                                    </span>
                                </div>
                                <div className="">
                                    {/* <h5 className="mb-2 text-slate-800 text-xl font-semibold header_blog_inner_heading py-5">
                                    {capitalInfra?.description}
                                </h5> */}
                                    <div className="table-wraper">
                                        <CustomTable
                                            className="ipo_blog_table prospect"
                                            columns={columnCapitalinfra}
                                            data={ipoDetailsCol}
                                            pagination={false}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </>
    )
}
